import React, { ReactElement } from 'react'
import BGMobile from 'images/topAwardBG/topAward_m_01.png'
import BGDesktop from 'images/topAwardBG/topAward_pc_01.png'
import styles from './topAwardSingle.module.sass'
import clsx from 'clsx'

interface ITopAwardSingle {
  titleImg: string
  awardImg: string
  content: string
  contentIcon?: ReactElement
  bannerBackgroundColor: string
  bannerBorderColor: string
  contentBackgroundColor: string
  contentBorderColor: string
  bgDesktopImg?: string
  bgMobileImg?: string
}

function TopAwardSingle(props: ITopAwardSingle) {
  const {
    titleImg,
    awardImg,
    content,
    contentIcon,
    bannerBackgroundColor,
    bannerBorderColor,
    contentBackgroundColor,
    contentBorderColor,
    bgDesktopImg,
    bgMobileImg
  } = props

  return (
    <div className={styles.root}>
      <div
        style={{
          borderColor: bannerBorderColor,
          backgroundColor: bannerBackgroundColor
        }}
        className={clsx(styles.titleContainer)}
      >
        <h4 className={styles.title}>
          <img src={titleImg} alt='title' />
        </h4>
      </div>
      <div
        style={{
          borderColor: contentBorderColor,
          backgroundColor: contentBackgroundColor
        }}
        className={clsx(styles.content, 'relative')}
      >
        <div className={clsx(styles.awardBG, 'm:flex hidden')}>
          <div className={styles.awardM}>
            <img src={awardImg} alt='award' />
          </div>
          {bgMobileImg ? (
            <img src={bgMobileImg} alt='bg-mobile' />
          ) : (
            <img src={BGMobile} alt='bg-mobile' />
          )}
        </div>
        <div className={clsx(styles.awardD)}>
          <img src={awardImg} alt='award' />
        </div>
        <div className={clsx(styles.awardBG, 'block m:hidden')}>
          {bgDesktopImg ? (
            <img src={bgDesktopImg} alt='awardBG' />
          ) : (
            <img src={BGDesktop} alt='awardBG' />
          )}
        </div>
        <div className={styles.contentContainer}>
          {contentIcon}
          <div className={styles.contentText} dangerouslySetInnerHTML={{ __html: content }} />
        </div>
      </div>
    </div>
  )
}

export default TopAwardSingle
